:root {
  --primitives-colors-brand-primary: #D70003;
  --primitives-colors-brand-secondary: #EBFA63;
  --primitives-colors-neutral-0: #FFFFFF;
  --primitives-colors-neutral-50: #EFEEF0;
  --primitives-colors-neutral-100: #EFEEF0;
  --primitives-colors-neutral-300: #BAB9C0;
  --primitives-colors-neutral-400: #94939D;
  --primitives-colors-neutral-600: #63616C;
  --primitives-colors-neutral-910: #373333;
  --primitives-colors-neutral-930: #302E2E;
  --primitives-colors-neutral-950: #28272A;
  --primitives-colors-neutral-970: #191919;
  --primitives-colors-neutral-980: #090909;
  --primitives-colors-neutral-990: #0F0F0F;
  --primitives-colors-functional-success: #00D3A3;
  --primitives-colors-functional-error: #FF575A;
  --primitives-colors-functional-information: #59C2E5;
  --primitives-colors-functional-warning: #FFC815;
  --primitives-colors-other-neutral-0-0: rgba(255, 255, 255, 0);
  --primitives-colors-other-neutral-0-5: rgba(255, 255, 255, 0.05);
  --primitives-colors-other-neutral-0-10: rgba(255, 255, 255, 0.1);
  --primitives-colors-other-neutral-0-20: rgba(255, 255, 255, 0.2);
  --primitives-colors-other-neutral-0-40: rgba(255, 255, 255, 0.4);
  --primitives-colors-other-neutral-100-10: rgba(239, 238, 240, 0.1);
  --primitives-colors-other-neutral-100-40: rgba(239, 238, 240, 0.4);
  --primitives-colors-other-neutral-600-40: rgba(99, 97, 108, 0.4);
  --primitives-colors-other-neutral-950-40: rgba(40, 39, 42, 0.4);
  --primitives-colors-other-neutral-990-40: rgba(15, 15, 15, 0.4);
  --primitives-colors-other-bg-tertiary-40: rgba(25, 25, 25, 0.4);
  --primitives-colors-other-bg-tertiary-70: rgba(25, 25, 25, 0.7);
  --primitives-colors-other-bg-tertiary-80: rgba(25, 25, 25, 0.8);
  --primitives-colors-other-bg-secondary-0: rgba(9, 9, 9, 0);
  --primitives-colors-other-bg-secondary-25: rgba(9, 9, 9, 0.25);
  --primitives-colors-other-bg-secondary-40: rgba(9, 9, 9, 0.4);
  --primitives-colors-other-bg-secondary-60: rgba(9, 9, 9, 0.6);
  --primitives-colors-other-brand-secondary-0: rgba(235, 250, 99, 0);
  --primitives-colors-other-brand-secondary-40: rgba(235, 250, 99, 0.4);
  --primitives-colors-other-brand-secondary-400: #DAF02B;
  --primitives-colors-other-brand-secondary-600: #92AB05;
  --primitives-colors-other-purple-600: #8036F1;
  --primitives-colors-other-purple-400: #9563FA;
  --primitives-colors-other-purple-200: #C5B3FF;
  --primitives-colors-other-studio-2: #64FAD0;
  --primitives-colors-other-bg-red: rgba(199, 27, 27, 0.1);
  --primitives-colors-other-bg-green: rgba(0, 211, 163, 0.1);
  --primitives-colors-other-bg-orange: rgba(255, 200, 21, 0.1);
  --primitives-typography-weight-bold: 700;
  --primitives-typography-weight-semibold: 600;
  --primitives-typography-weight-medium: 500;
  --primitives-typography-weight-regular: 400;
  --primitives-typography-family-heading: "DM Sans";
  --primitives-typography-family-body: "DM Sans";
  --primitives-typography-family-caption: "DM Sans";
  --primitives-typography-size-heading-lg: 32px;
  --primitives-typography-size-heading-md: 24px;
  --primitives-typography-size-heading-sm: 20px;
  --primitives-typography-size-heading-xs: 18px;
  --primitives-typography-size-heading-xxs: 16px;
  --primitives-typography-size-heading-tiny: 14px;
  --primitives-typography-size-body-md: 16px;
  --primitives-typography-size-body-sm: 14px;
  --primitives-typography-size-body-xs: 12px;
  --primitives-typography-size-body-xxs: 10px;
  --primitives-typography-letter-spacing-heading: 0px;
  --primitives-typography-letter-spacing-body: 0px;
  --primitives-typography-letter-spacing-caption: 1px;
  --primitives-typography-line-height-heading-lg: 36px;
  --primitives-typography-line-height-heading-md: 28px;
  --primitives-typography-line-height-heading-sm: 24px;
  --primitives-typography-line-height-heading-xs: 22px;
  --primitives-typography-line-height-heading-xxs: 20px;
  --primitives-typography-line-height-heading-xxxs: 16px;
  --primitives-typography-line-height-body-md: 25px;
  --primitives-typography-line-height-body-sm: 22px;
  --primitives-typography-line-height-body-xs: 20px;
  --primitives-typography-line-height-body-xxs: 13px;
  --primitives-values-value--2: -2px;
  --primitives-values-value-0: 0px;
  --primitives-values-value-1: 1px;
  --primitives-values-value-1-5: 1.5px;
  --primitives-values-value-2: 2px;
  --primitives-values-value-2-5: 2.5px;
  --primitives-values-value-3: 3px;
  --primitives-values-value-4: 4px;
  --primitives-values-value-6: 6px;
  --primitives-values-value-8: 8px;
  --primitives-values-value-10: 10px;
  --primitives-values-value-11: 11px;
  --primitives-values-value-12: 12px;
  --primitives-values-value-14: 14px;
  --primitives-values-value-16: 16px;
  --primitives-values-value-18: 18px;
  --primitives-values-value-20: 20px;
  --primitives-values-value-22: 22px;
  --primitives-values-value-24: 24px;
  --primitives-values-value-26: 26px;
  --primitives-values-value-28: 28px;
  --primitives-values-value-32: 32px;
  --primitives-values-value-36: 36px;
  --primitives-values-value-40: 40px;
  --primitives-values-value-44: 44px;
  --primitives-values-value-48: 48px;
  --primitives-values-value-52: 52px;
  --primitives-values-value-56: 56px;
  --primitives-values-value-64: 64px;
  --primitives-values-value-72: 72px;
  --primitives-values-value-80: 80px;
  --primitives-values-value-88: 88px;
  --primitives-values-value-96: 96px;
  --primitives-values-value-104: 104px;
  --primitives-values-value-112: 112px;
  --primitives-values-value-120: 120px;
  --primitives-values-value-128: 128px;
  --primitives-values-value-999: 999px;
}
